import React, { useState, useEffect } from "react";
import RenderScoreHtml from "./scoreComponent";
import fetchGithubProfileData from "./githubProfileData"; // Import function

function HeroSection() {
  const searchParams = new URLSearchParams(window.location.search);
  const username = searchParams.get("user"); // Extract `user` from URL

  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    if (!username) return; // Prevent API call if username is null

    const fetchData = async () => {
      const data = await fetchGithubProfileData(username.trim()); // Ensure username is a string
      setProfileData(data);
    };

    fetchData();
  }, [username]); // Re-fetch when username changes

  if (!profileData) {
    return <p>Loading...</p>; // Show loading while fetching data
  }

  const avatarUrl = `https://github.com/${username}.png`;

  return (
    <main className="heroSection section--lg">
      <div className="avatarContainer">
        <img src={avatarUrl} alt="Profile" style={{width:'105px', height: 'auto' }}/>
      </div>
      <div className="nameContainer">
        <h2 className="userName">{profileData.username!=null ? profileData.username : username}</h2>
        <h5 className="userId">@{username}</h5>
      </div>
      <div className="profileStats">
        <div className="repoContainer">
          <h3 className="repoCount">{profileData.total_repos}</h3>
          <h5 className="repoack">Total Repos</h5>
        </div>
        <div className="followersContainer">
          <h3 className="followerCount">{profileData.followers}</h3>
          <h5 className="followersack">Followers</h5>
        </div>
        <div className="followingContainer">
          <h3 className="followingCount">{profileData.following}</h3>
          <h5 className="followingack">Following</h5>
        </div>
      </div>
      <RenderScoreHtml />
    </main>
  );
}

export default HeroSection;
